




















































































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import {
  FETCH_SYSTEM_LIST,
  CREATE_SYSTEM_LIST,
  GET_SYSTEM_LIST,
  GET_REGISTER_SYSTEM_FORM_VISIBILITY,
  UPDATE_REGISTER_FORM_VISIBILITY,
  UPDATE_SELECTED_SYSTEM,
} from '@/modules/system/store';
import { ISystem } from '@/modules/system/models';
import { RootState } from '@/store';
import { getEnabledCategories } from 'trace_events';
import { nameof } from 'ts-simple-nameof';
import { IAuthUser } from '@/modules/home/models';
import { GET_LOGGED_USER } from '@/modules/home/store/types';

@Component
export default class extends Vue {
  public isLoading: boolean = false;
  public showRegisterForm: boolean = false;
  public search: string = '';
  public selected: any[] = [];
  public headersStores: any[] = [
    { text: 'Nome', value: 'systemname'},
    { text: 'Status', value: 'isactive'},
  ];

  public pagination: any = {
    sortBy: 'systemname',
    descending: false,
  };

    @Getter(GET_LOGGED_USER)
  public authUser: IAuthUser;

  @Getter(GET_SYSTEM_LIST)
  public systems: ISystem[];

  @Getter(GET_REGISTER_SYSTEM_FORM_VISIBILITY)
  public showSystemForm: boolean;

  @Action(FETCH_SYSTEM_LIST)
  private getAllSystems: any;

  @Action(CREATE_SYSTEM_LIST)
  private setAllSystems: any;

  @Action(UPDATE_SELECTED_SYSTEM)
  private setSelectedSystem: any;

  @Action(UPDATE_REGISTER_FORM_VISIBILITY)
  private setShowRegisterForm: any;

  public created() {
     this.isLoading = true;
     this.getAllSystems()
      .then((ret: any) => {
        console.log(ret);
        const systems: ISystem[] = ret.data;
        this.setAllSystems(systems);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  public habilitarCadastro() {
    this.setShowRegisterForm(!this.showSystemForm);
  }

  public selectSystem(selectedSystem: ISystem) {
    this.setSelectedSystem(selectedSystem);
    this.setShowRegisterForm(true);
  }

  public getBadgeColor(icatv: boolean) {
    return icatv ? 'teal' : 'red';
  }
}
